// extracted by mini-css-extract-plugin
module.exports = {"topics":"topics-module--topics--DjgkS","overlay":"topics-module--overlay--ZRl_L","image":"topics-module--image--3YGj6","placeholder":"topics-module--placeholder--33Yje"};